import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ApplicantWrapperComponent } from '@core/components/applicant-wrapper/applicant-wrapper.component';
import { DownloadFilePageComponent } from '@core/components/download-file-page/download-file-page.component';
import { SSOLogoutComponent } from '@core/components/sso-logout/sso-logout.component';
import { SSORedirectComponent } from '@core/components/sso-redirect/sso-redirect.component';
import { canAccessPortalGuard } from '@core/guards/can-access-portal.guard';
import { featureFlagsResolver } from '@core/resolvers/feature-flags.resolver';
import { initialRedirectResolver } from '@core/resolvers/initial-redirect.resolver';
import { languageResolver } from '@core/resolvers/language-resolver';
import { localeResolver } from '@core/resolvers/locale.resolver';
import { staticResourceSASResolver } from '@core/resolvers/static-resource-sas.resolver';
import { unauthenticatedGuard } from '@features/auth/unauthenticated.guard';

@NgModule({
  imports: [
    RouterModule.forChild([{
      path: '',
      resolve: {
        redirect: initialRedirectResolver,
        locale: localeResolver,
        language: languageResolver
      },
      data: {
        namespace: ['GLOBAL', 'AUTH', 'classification']
      },
      children: [{
        path: '',
        children: [{
          path: 'auth',
          canActivate: [
            unauthenticatedGuard
          ],
          loadChildren: () => import('@features/auth/applicant-auth.module').then(m => m.ApplicantAuthModule)
        }, {
          path: 'sso_redirect',
          component: SSORedirectComponent
        }, {
          path: 'ssologout',
          component: SSOLogoutComponent
        }]
      }, {
        // Logged in
        path: '',
        component: ApplicantWrapperComponent,
        data: {
          namespace: ['APPLY', 'nonprofits']
        },
        resolve: {
          featureFlags: featureFlagsResolver,
          redirect: initialRedirectResolver,
          sas: staticResourceSASResolver,
          locales: localeResolver
        },
        canActivate: [
          canAccessPortalGuard
        ],
        children: [{
          path: 'download-file',
          component: DownloadFilePageComponent
        }, {
          path: 'my-account',
          loadChildren: () => import('@features/my-account/applicant-account.module').then(m => m.ApplicantAccountModule),
          data: { pageName: 'Applicant Portal - My Account' }
        }, {
          path: 'terms-and-conditions',
          loadChildren: () => import('@features/terms-and-conditions/terms-and-conditions-routing.module').then(m => m.TermsAndConditionsRoutingModule),
          data: { pageName: 'Applicant Portal - Terms and Conditions' }
        }, {
          path: 'awards',
          loadChildren: () => import('@features/applicant-awards/applicant-awards-routing.module').then(m => m.ApplicantAwardsRoutingModule),
          data: { pageName: 'Applicant Portal - Awards' }
        }, {
          path: 'invitations',
          loadChildren: () => import('@features/my-invitations/my-invitations-routing.module').then(m => m.MyInvitationsRoutingModule),
          data: { pageName: 'Applicant Portal - Invitations' }
        }, {
          path: 'programs',
          loadChildren: () => import('@features/apply/program-routing.module').then(m => m.ProgramRoutingModule),
          data: { pageName: 'Program Landing Page' }
        }, {
          path: 'applications',
          loadChildren: () => import('@features/my-applications/my-applications-routing.module').then(m => m.MyApplicationsRoutingModule),
          data: { pageName: 'Applicant Portal - My Applications' }
        }, {
          path: 'application',
          loadChildren: () => import('@features/apply/application-routing.module').then(m => m.ApplicationRoutingModule),
          data: { pageName: 'Application Landing Page' }
        }]
      }]
    }])
  ]
})
export class ApplyPortalRoutingModule { }
